var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{attrs:{"id":"sections-menu"}},_vm._l((_vm.sections),function(s,index){return _c('li',{key:index,staticClass:"sections-list"},[_c('div',{staticClass:"section-link",class:_vm.activeIndex === index ? 'active' : '',on:{"click":function($event){return _vm.jump(s)}}},[_vm._v(" "+_vm._s(s.name)+" ")])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }